import script from "./FastDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./FastDownload.vue?vue&type=script&setup=true&lang=js"

import "./FastDownload.vue?vue&type=style&index=0&id=6c1c68e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c1c68e7"]])

export default __exports__